/** @jsx jsx */
import { css } from '@emotion/core';
import helperUtils from '../utils/helper.util';
import baseStyles from './base.styles';

const wrapperClass = css`
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f4f4f4;
`;

const columnWidth = (width, cellType) => {
  let addStyle = '';
  if (cellType === 'WIDGET') {
    addStyle = `
      text-align:center;
      width: ${width}%;
    `;
  }

  return css`
    width: ${width}%;
    ${addStyle}
  `;
};

//@todo delete comments once table scroll resolution is in place
const tBodyStyle = (theme, height) => css`
  // ${height ? `height: ${height}px;` : ''}
  // display: inline-block;
  // overflow-y: ${height ? 'auto' : 'hidden'};
  // overflow-x: hidden !important;
  width: 100%;
`;

const trWrapper = theme => css`
  min-height: 4rem;
  vertical-align: inherit;
  border-color: inherit;
  width: 100%;
  ${baseStyles.offsetStyleRowForType(theme, 'even')}
`;

const tableWrapper = ({ minWidth }) => theme => css`
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  min-width: ${minWidth};

  & div[data-test$="-cybsMenuButton"], div[data-test$="-cybsCombobox"] {
    position: static;
  }

  &:focus {
    outline: 1px dashed;
    ${theme?.classes?.skin?.outline?.element?.dark?.styles ?? 'outline-color: #222222'};
    outline-offset: -1px;
  }

   tbody {
      ${baseStyles.offsetStyleRowForType(theme, 'even')}
    }
    .gridRow {
      vertical-align: inherit;
      border-color: inherit;

    }

    table.vds-datagrid .vds-checkbox-label {
      margin-left: 0 !important;
    }

    .gridRowHeader th {
      /* display: inline-flex; */
      align-items: center;
    }

    .gridRowHeader th, .gridRow td{
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.left.2'
        )
          ? theme.classes.structure.padding.space.left[2]
          : 'padding-left:1.0rem;label:structPadding;'
      };
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.right.2'
        )
          ? theme.classes.structure.padding.space.right[2]
          : 'padding-right:1.0rem;label:structPadding;'
      };
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.top.1'
        )
          ? theme.classes.structure.padding.space.top[1]
          : 'padding-top:0.5rem;label:structPadding;'
      };
       ${
         helperUtils.checkObjectForDataPath(
           theme,
           'classes.structure.padding.space.bottom.1'
         )
           ? theme.classes.structure.padding.space.bottom[1]
           : 'padding-bottom:0.5rem;label:structPadding;'
       };
      vertical-align: middle;
      word-break: break-all;
      color: ${baseStyles.tableAltColor(theme)};
    }

    .paddingHeader {
      ${
        helperUtils.checkObjectForDataPath(
          theme,
          'classes.structure.padding.space.right.2'
        )
          ? theme.classes.structure.padding.space.right[2]
          : 'padding-right:1.0rem;label:structPadding;'
      }
    }

    .gridRowHeader {
      ${baseStyles.offsetStyleRowForType(theme, 'even')}
      ${baseStyles.borderBottomLine(theme)}
      display: table-row;
      vertical-align: middle;
      color: ${baseStyles.tableAltColor(theme)};
    }

    input {
      outline: none,
      border: 0
    }

    input[type=text]::-ms-clear {
      display: none;
    }

    *:focus, input:focus {
      outline: 1px dashed ${
        helperUtils.checkObjectForDataPath(
          theme,
          'variables.colors.element.dark'
        )
          ? theme.variables.colors.element.dark
          : 'rgba(42,46,105,1)'
      };
    }

    input[type=text]:focus{
      outline: 0 !important;
    }
`;

export default {
  columnWidth,
  trWrapper,
  wrapperClass,
  tableWrapper,
  tBodyStyle
};
